import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<button class=\"button\">Toggle Dark Mode</button><div class=\"rays\"><div class=\"ray\"></div><div class=\"ray\"></div><div class=\"ray\"></div><div class=\"ray\"></div></div>", 2)
const _hoisted_3 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_title_vue = _resolveComponent("title-vue")!
  const _component_summary_vue = _resolveComponent("summary-vue")!
  const _component_education_vue = _resolveComponent("education-vue")!
  const _component_work_vue = _resolveComponent("work-vue")!
  const _component_projects_vue = _resolveComponent("projects-vue")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(_ctx.darkMode ? 'dark' : 'light')
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(['dark-mode-toggle']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDarkMode()))
    }, _hoisted_3),
    _createVNode(_component_title_vue),
    _createVNode(_component_summary_vue),
    _createVNode(_component_education_vue),
    _createVNode(_component_work_vue),
    _createVNode(_component_projects_vue)
  ], 2))
}